import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿SAINT® es adecuada después de que la medicación haya fallado?",
    answer:
      "SAINT® está indicada para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos. Si la medicación no ha funcionado lo suficiente, una consulta con el equipo clínico puede determinar si SAINT® es adecuada.",
  },
];

export const esSaintAfterMedFailure = makeEsArticle({
  slug: "saint-after-medication-failure",
  title: "SAINT® después de que la medicación no haya funcionado",
  description:
    "Cuando los antidepresivos no han funcionado lo suficiente, SAINT® es una opción autorizada por la FDA para el trastorno depresivo mayor en adultos.",
  h1: "SAINT® después de que la medicación no haya funcionado",
  breadcrumbLabel: "SAINT® tras fallar la medicación",
  shortAnswer:
    "Cuando los antidepresivos no han producido una mejoría suficiente, SAINT® es una opción autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. SAINT® combina 50 sesiones en cinco días con orientación individualizada por fMRI y patrón theta burst. No hay garantías de resultados; los resultados individuales pueden variar. El siguiente paso es una consulta con el equipo clínico para confirmar la elegibilidad.",
  keyTakeaways: [
    "SAINT® es una opción cuando los antidepresivos no han funcionado lo suficiente.",
    "Está autorizada por la FDA para el trastorno depresivo mayor en adultos.",
    "Combina 50 sesiones en cinco días con orientación por fMRI.",
    "No hay garantías; los resultados pueden variar.",
    "El siguiente paso es una consulta.",
  ],
  sections: [
    {
      heading: "Cuando la medicación no ha bastado",
      paragraphs: [
        "Si los antidepresivos no han producido una mejoría suficiente, SAINT® es una opción autorizada por la FDA para el trastorno depresivo mayor en adultos. La elegibilidad se confirma mediante una evaluación psiquiátrica que revisa el historial de medicación y criba contraindicaciones.",
        "No está indicada para ansiedad, trastorno bipolar, TEPT u otras condiciones. Los resultados individuales pueden variar y no están garantizados.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
